import { z } from 'zod';

/**
 * The chat card for a skill the agent created or changed after the user approved it.
 * Carries the name as it was saved, so the card and a plain-text reply can say which skill
 * without another query.
 */
export const AgentSkillAiResultSchema = z.object({
  action: z.enum(['created', 'updated']),
  name: z.string(),
  skillId: z.uuid(),
  type: z.literal('agent-skill'),
});
export type AgentSkillAiResult = z.infer<typeof AgentSkillAiResultSchema>;

export const SkillAuthoringResultSchema = z.union([
  z.object({ name: z.string(), skillId: z.uuid(), status: z.enum(['created', 'updated']) }),
  z.object({
    message: z.string(),
    status: z.enum(['blocked', 'failed', 'interrupted']),
  }),
]);
export type SkillAuthoringResult = z.infer<typeof SkillAuthoringResultSchema>;

export function parseSkillAuthoringResult(output: unknown): SkillAuthoringResult | null {
  let value = output;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch {
      return null;
    }
  }
  const parsed = SkillAuthoringResultSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
